import { Icon } from "@iconify/react";
import { format } from "date-fns";
import { forwardRef, useState } from "react";
import DatePicker from "react-datepicker";
import Pagination from "../Pagination";
import Modal from "react-modal";
import { exportReport, updateExchangeRate } from "../../../callApi/httpservice";
import SpinnerCustom from "../../common/SpinnerCustom";
import SkeletonTable from "../../common/SkeletonTable";
import { converPrice } from "../../../utils/convert-price";
import { useStores } from "../../../srores";
import { DATA_SOURCE } from "../../../constants/admin.constants";
interface ComponentProps {
  setStartDate: any;
  startDate: Date;
  items: any;
  pageCount: number;
  handlePageClick: any;
  offset: any;
  setItemEdit: any;
  itemEdit: any;
  setItems: any;
  isFetching: boolean;
}
export default function ManagerExchangeRateTable(props: ComponentProps) {
  const { adminStore } = useStores();
  const {
    setStartDate,
    startDate,
    items,
    pageCount,
    handlePageClick,
    offset,
    setItemEdit,
    itemEdit,
    setItems,
    isFetching,
  } = props;

  const [editSellingRateModal, setEditSellingRateModal] =
    useState<boolean>(false);
  const [editVarianceModal, setEditVarianceModal] = useState<boolean>(false);
  const [newVariance, setNewVariance] = useState<string>("");
  const [newVarianceErr, setNewVarianceErr] = useState<string>("");
  const [newRate, setNewRate] = useState<string>("");
  const [newRateErr, setNewRateErr] = useState<string>("");
  const [isWaitingSaving, setIsWaitingSaving] = useState<boolean>(false);
  const [isWaitingSavingVariance, setIsWaitingSavingVariance] =
    useState<boolean>(false);
  const [exportReportModal, setExportReportModal] = useState<boolean>(false);
  const [startDateExport, setStartDateExport] = useState<any>(new Date());
  const [endDateExport, setEndDateExport] = useState<any>(new Date());
  const [isWaitingExport, setWaitingExport] = useState<boolean>(false);
  const [dateExportErr, setDateExportErr] = useState<string>("");
  const closeModal = () => {
    setEditSellingRateModal(false);
  };
  const closeModalEditVariance = () => {
    setEditVarianceModal(false);
  };
  const customStyles = {
    content: {
      background: "white",
      top: adminStore.windowWidth > 768 ? "50%" : "40%",
      left: "50%",
      right: "50%",
      bottom: "auto",
      transform: "translate(-50%, -50%)",
      border: "none",
      width:
        adminStore.windowWidth > 1280
          ? "475px"
          : adminStore.windowWidth > 480
          ? "380px"
          : "90%",
      boxShadow: " 0 3px 7px rgba(0, 0, 0, 0.3)",
      borderRadius: 10,
    },
  };
  const Input = forwardRef(
    ({ onChange, placeholder, value, id, onClick }: any, ref) => (
      <div className="flex relative fullwidth-datepicker">
        <div className="w-[100%]">
          <input
            onChange={onChange}
            placeholder={placeholder}
            value={value}
            id={id}
            onClick={onClick}
            style={{ border: "1px solid #EED484" }}
          />
        </div>
        <div className="absolute top-[13px] right-[5%]">
          <Icon
            icon="fluent-mdl2:page-list-filter"
            width={16}
            className=" cursor-pointer"
            onClick={onClick}
          />
        </div>
      </div>
    )
  );

  const collums = [
    "Currency code",
    "Currency name",
    "Local currency",
    "Techcombank's buying rate",
    "Techcombank's selling rate",
    "Variance",
    "ROE (publish on website)",
  ];
  const onDateChange = (date: any) => {
    setStartDate(date);
  };
  const onIconEditSellingRateClick = (item: any) => {
    setItemEdit(item);
    setEditSellingRateModal(true);
  };

  const onIconEditVarianceClick = (item: any) => {
    setItemEdit(item);
    setEditVarianceModal(true);
  };

  const onSaveChangeBtnClick = async () => {
    setIsWaitingSaving(true);
    const checkValid = validate();
    if (checkValid) {
      const result: any = await updateExchangeRate(itemEdit.id, {
        sellingPrice: +newRate,
      });
      let newItems = items;
      if (result.status === 200) {
        for (let i = 0; i < newItems.length; i++) {
          if (newItems[i].id === itemEdit.id) {
            newItems[i].sellingPrice = result.data.sellingPrice;
            newItems[i].dataSource = result.data.dataSource;
            break;
          }
        }
        setItems(newItems);
        setNewRate("");
        closeModal();
      }
    }
    setIsWaitingSaving(false);
  };

  const onSaveVarianceBtnClick = async () => {
    const checkValid = validateVariance();
    if (checkValid) {
      setIsWaitingSavingVariance(true);
      const result: any = await updateExchangeRate(itemEdit.id, {
        variance: +newVariance,
      });
      let newItems = items;
      if (result.status === 200) {
        for (let i = 0; i < newItems.length; i++) {
          if (newItems[i].id === itemEdit.id) {
            newItems[i].variance = result.data.variance;
            newItems[i].dataSource = result.data.dataSource;
            newItems[i].varianceEdited = result.data.varianceEdited;
            break;
          }
        }
        setItems(newItems);
        setNewVariance("");
        closeModalEditVariance();
      }
      setIsWaitingSavingVariance(false);
    }
  };

  const validate = () => {
    setNewRateErr("");
    let msg: any = {};
    if (newRate.trim() === "") {
      msg.newRate = "New rate is required";
      setNewRateErr("New rate is required");
    }
    if (newRate.trim() !== "") {
      if (+newRate <= 0) {
        msg.newRate = "New rate is not less than or equal to zero";
        setNewRateErr("New rate is not less than or equal to zero");
      }
    }
    if (Object.keys(msg).length > 0) return false;
    return true;
  };

  const validateVariance = () => {
    setNewVarianceErr("");
    let msg: any = {};
    if (newVariance.trim() === "") {
      msg.newVariance = "New variance is required";
      setNewVarianceErr("New variance is required");
    }
    if (newVariance.trim() !== "") {
      if (+newVariance < 0) {
        msg.newVariance = "New variance is not less than zero";
        setNewVarianceErr("New variance is not less than zero");
      }
      if (+newVariance >= 100) {
        msg.newVariance = "New variance is not greater than or equal to 100";
        setNewVarianceErr("New variance is not greater than or equal to 100");
      }
    }
    if (Object.keys(msg).length > 0) return false;
    return true;
  };
  function onStartDateExportChange(date: any) {
    setStartDateExport(date);
  }
  function onEndDateExportChange(date: any) {
    setEndDateExport(date);
  }
  const closeModalExport = () => {
    setExportReportModal(false);
  };

  const onExportClick = () => {
    setExportReportModal(true);
  };

  const onExportReportClick = async () => {
    const checkValid = validateExport();
    if (checkValid) {
      setWaitingExport(true);
      let start = new Date(startDateExport);
      let end = new Date(endDateExport);
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 999);
      await exportReport({
        skip: 0,
        sortDesc: true,
        sortBy: "createdAt",
        startAt: Math.floor(new Date(start).getTime() / 1000),
        endAt: Math.floor(new Date(end).getTime() / 1000),
      });
      setWaitingExport(false);
      setExportReportModal(false);
      setStartDateExport(new Date());
      setEndDateExport(new Date());
    }
  };
  const validateExport = () => {
    setDateExportErr("");
    let msg: any = {};
    if (new Date(endDateExport) < new Date(startDateExport)) {
      msg.endDateExport = "This date is not valid";
      setDateExportErr("This date is not valid");
    }
    if (Object.keys(msg).length > 0) return false;
    return true;
  };
  console.log(converPrice(((0.5 + 100) / 100) * 25100))
  return (
    <div>
      <div className="flex lg:justify-between xsm:flex-col lg:flex-row lg:items-center">
        <div className=" text-[#242424] font-bold xsm:text-[16px] xs:text-[18px]">
          {"Manage exchange rate"}
        </div>
        <div className="flex lg:gap-10 xsm:gap-1 items-center xsm:justify-between lg:justify-end xsm:mt-3 lg:mt-0">
          <div className="flex xsm:mt-2 lg:mt-0">
            <DatePicker
              customInput={<Input />}
              dateFormat="dd/MM/yyyy"
              selected={startDate}
              onChange={(date) => onDateChange(date)}
              popperPlacement="bottom-end"
              calendarStartDay={1}
            />
          </div>
          <div className="flex text-[14px]">
            <span className="xsm:hidden xs:block mr-2">Date filled: </span>
            {format(startDate, "dd/MM/yyyy")}
          </div>
          <div
            className="bg-[#EED484] text-[14px]  xsm:py-2 xsm:px-2 lg:py-2 lg:px-10 rounded-2xl text-center hover:bg-[#dac176] cursor-pointer flex items-center xsm:gap-x-1 lg:gap-x-2"
            onClick={() => {
              onExportClick();
            }}
          >
            Export report
            <Icon icon={"material-symbols:export-notes-rounded"} width={20} />
          </div>
        </div>
      </div>
      <hr className="mt-3" />
      <div className="flex flex-col">
        <div className="overflow-x-auto">
          <div className=" pt-2 w-full inline-block align-middle">
            <div className=" xl:overflow-hidden xsm:overflow-x-scroll border rounded-lg">
              <table className="min-w-full xl:overflow-hidden xsm:overflow-x-scroll">
                <thead className="bg-[#222221]">
                  <tr className="text-[#EED484] text-center font-bold text-xs">
                    {collums.map((collum, index: any) => (
                      <th scope="col" className="px-6 py-3" key={index}>
                        {collum}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="">
                  {items &&
                    items.map((item: any, index: number) => (
                      <tr
                        className={
                          (index + 1) % 2
                            ? " text-[#222221] text-center bg-white"
                            : " text-[#222221] text-center bg-[#E0E0E0]"
                        }
                        key={index}
                      >
                        <td className="px-6 py-4">{item.currencyCode}</td>
                        <td className="px-6 py-4">{item.currency.name}</td>
                        <td className="px-6 py-4">{item.currency.local}</td>
                        <td className="px-6 py-4">
                          {item.buyingPrice ? (
                            converPrice(item.buyingPrice)
                          ) : (
                            <span className="text-[#A6192E]">Error</span>
                          )}
                        </td>
                        <td className="px-6 py-4 ">
                          <div className="flex items-center">
                            <div
                              className={`${
                                item.dataSource === DATA_SOURCE.TCB
                                  ? " text-lime-700 text-center flex justify-center w-[100%]"
                                  : item.dataSource === DATA_SOURCE.MSC
                                  ? " text-orange-400 text-center flex justify-center w-[100%]"
                                  : "text-center flex justify-center w-[100%]"
                              }`}
                            >
                              {item.sellingPrice ? (
                                converPrice(item.sellingPrice)
                              ) : (
                                <span className="text-[#A6192E]">Error</span>
                              )}
                            </div>
                            <div
                              className="flex items-center justify-end cursor-pointer"
                              onClick={() => {
                                onIconEditSellingRateClick(item);
                              }}
                            >
                              <Icon
                                icon={"material-symbols:edit"}
                                width={adminStore.windowWidth > 480 ? 18 : 15}
                              />
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 ">
                          <div className="flex items-center ">
                            <div className="text-center flex justify-center w-[100%]">
                              {item.variance === null ? (
                                <span className="text-[#A6192E]">Error</span>
                              ) : (
                                <span
                                  className={
                                    item.varianceEdited ? "text-orange-400" : ""
                                  }
                                >
                                  {item.variance}%
                                </span>
                              )}
                            </div>
                            <div
                              className="flex items-center justify-end cursor-pointer"
                              onClick={() => {
                                onIconEditVarianceClick(item);
                              }}
                            >
                              <Icon
                                icon={"material-symbols:edit"}
                                width={adminStore.windowWidth > 480 ? 18 : 15}
                              />
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4">
                          {item.sellingPrice && item.variance !== null ? (
                            converPrice(
                              ((item.variance + 100) / 100) * item.sellingPrice
                            )
                          ) : (
                            <span className="text-[#A6192E]">Error</span>
                          )}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {isFetching && !items && (
        <div className="mt-5">
          <SkeletonTable row={5} />
        </div>
      )}
      {!isFetching && items?.length === 0 && (
        <div className="text-center text-black mt-10 text-[14px]">
          Data is empty!
        </div>
      )}
      <div className=" flex justify-end mt-2 items-center">
        {pageCount > 0 && (
          <div className="flex items-center justify-center">
            <Pagination
              pageCount={pageCount}
              handlePageClick={handlePageClick}
              offset={offset}
            />
          </div>
        )}
      </div>

      <Modal
        isOpen={editSellingRateModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Edit currency modal"
        ariaHideApp={false}
      >
        <div className="flex-col">
          <div className="flex justify-between">
            <div className="text-xl">Manual input</div>
            <Icon
              icon={"ic:round-close"}
              width={20}
              className=" cursor-pointer hover:text-zinc-600"
              onClick={closeModal}
            />
          </div>
          <div className="mb-4 mt-2 w-full text-[14px]">
            <label className="block text-gray-700 mb-1" htmlFor="new-rate">
              New rate
            </label>
            <input
              className="bg-[#F2F2F2] w-full appearance-none rounded-md py-2 px-3 text-gray-700 leading-tight focus:shadow-outline"
              style={{ border: "1px solid #EED484" }}
              id="new-rate"
              type="number"
              value={newRate}
              onChange={(e) => {
                setNewRate(e.target.value);
              }}
            />
            <div className="text-[12px] text-red-500">{newRateErr}</div>
          </div>
          <div className="flex justify-center mt-10">
            <div className="w-[30%] h-[5px] bg-[#EED484]"></div>
          </div>
          <div className="flex justify-center mt-7">
            <div
              className="bg-[#EED484] text-[14px] xsm:text py-2 px-3 xsm:w-[80%] lg:w-[40%] rounded-2xl text-center hover:bg-[#dac176] cursor-pointer flex gap-2 justify-center"
              style={{
                pointerEvents: `${isWaitingSaving ? "none" : "unset"}`,
              }}
              onClick={() => {
                onSaveChangeBtnClick();
              }}
            >
              {isWaitingSaving ? (
                <SpinnerCustom />
              ) : (
                <span className="font-bold mr-2">&rsaquo; </span>
              )}
              Save change
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={editVarianceModal}
        onRequestClose={closeModalEditVariance}
        style={customStyles}
        contentLabel="Edit variance modal"
        ariaHideApp={false}
      >
        <div className="flex-col">
          <div className="flex justify-between">
            <div className="text-xl">Manual input</div>
            <Icon
              icon={"ic:round-close"}
              width={20}
              className=" cursor-pointer hover:text-zinc-600"
              onClick={closeModalEditVariance}
            />
          </div>
          <div className="mb-4 mt-2 w-full text-[14px]">
            <label className="block text-gray-700 mb-1" htmlFor="new-variance">
              New variance %
            </label>
            <input
              className="bg-[#F2F2F2] w-full appearance-none rounded-md py-2 px-3 text-gray-700 leading-tight focus:shadow-outline"
              style={{ border: "1px solid #EED484" }}
              id="new-variance"
              type="number"
              min={0}
              max={100}
              value={newVariance}
              onChange={(e) => {
                setNewVariance(e.target.value);
              }}
            />
            <div className="text-[12px] text-red-500">{newVarianceErr}</div>
          </div>
          <div className="flex justify-center mt-10">
            <div className="w-[30%] h-[5px] bg-[#EED484]"></div>
          </div>
          <div className="flex justify-center mt-7">
            <div
              className="bg-[#EED484] text-[14px] xsm:text py-2 px-3 xsm:w-[80%] lg:w-[40%] rounded-2xl text-center hover:bg-[#dac176] cursor-pointer flex gap-2 justify-center"
              style={{
                pointerEvents: `${isWaitingSavingVariance ? "none" : "unset"}`,
              }}
              onClick={() => {
                onSaveVarianceBtnClick();
              }}
            >
              {isWaitingSavingVariance ? (
                <SpinnerCustom />
              ) : (
                <span className="font-bold mr-2">&rsaquo; </span>
              )}
              Save change
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={exportReportModal}
        onRequestClose={closeModalExport}
        style={customStyles}
        contentLabel="Create currency modal"
        ariaHideApp={false}
      >
        <div className="flex flex-col p-2">
          <div className="flex justify-between">
            <div className="text-xl">Export report</div>
            <Icon
              icon={"ic:round-close"}
              width={20}
              className=" cursor-pointer hover:text-zinc-600"
              onClick={closeModalExport}
            />
          </div>
          <div className="flex flex-col mt-7 text-[14px]">
            <div className="mb-4 w-full">
              <label className="block text-gray-700 mb-1" htmlFor="new-export">
                Range
              </label>
              <div className="flex items-center gap-2">
                <DatePicker
                  customInput={<Input />}
                  dateFormat="dd/MM/yyyy"
                  selected={startDateExport}
                  onChange={(date) => onStartDateExportChange(date)}
                  popperPlacement="bottom-start"
                  calendarStartDay={1}
                />
                To
                <DatePicker
                  customInput={<Input />}
                  dateFormat="dd/MM/yyyy"
                  selected={endDateExport}
                  onChange={(date) => onEndDateExportChange(date)}
                  popperPlacement="bottom-end"
                  calendarStartDay={1}
                />
              </div>
              <div className="text-[12px] text-red-500">{dateExportErr}</div>
            </div>
          </div>
          <div className="flex justify-center mt-7 items-center">
            <div
              className="bg-[#EED484] text-[14px] items-center py-2 px-10 rounded-2xl text-center hover:bg-[#dac176] cursor-pointer flex gap-2"
              style={{
                pointerEvents: `${isWaitingExport ? "none" : "unset"}`,
              }}
              onClick={onExportReportClick}
            >
              {isWaitingExport ? (
                <SpinnerCustom />
              ) : (
                <span className=" mr-2">&rsaquo; </span>
              )}
              Export
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
